export default {
  "pages:home:menuLabel": "Home",
  "pages:company:menuLabel": "Company",
  "pages:products:menuLabel": "Products",
  "pages:services:menuLabel": "Services",
  "pages:projects:menuLabel": "Projects",
  "pages:procurement:menuLabel": "Activities",
  "pages:quality:menuLabel": "Quality",
  "pages:news:menuLabel": "News",
  "pages:contacts:menuLabel": "Contacts",

  "pages:home:title": "Putting ART in Technology",

  "pages:home:title": "Putting ART in Technology",
  "pages:home:news-title": "NEWS",
  "pages:home:news-sub-title": "NEW OPENING",
  "pages:home:news-content": "Renewable Energy Division",
  "pages:home:news-content-2": "LED Solar Street Light",

  "pages:company:title": "Company",
  "pages:company:description":
    "<p class='company-text-1'>A.R.Technology carries out trading, engineering and energy activities at international levels and it is leader in supplying goods destined to Oil & Gas, Energy, Upstream, Midstream and Downstream companies, ac- cording to quality requirements and in compliance with most international standards. It is specialized in bulk material packages (piping, valves, mechanical, instrumentation, electrical) where quality and time are essential for projects which require multiple commodities in one solution.</p><p style='text-align: right'><a href='documents/brochure.pdf' download><b>Download Brochure</b></a></p>",

  "pages:products:title": "Products",
  "pages:products:description": `
    <div class="product-category">
      <h2>Piping Bulk Material</h2>
      <img src='images/products/Piping_Bulk_Material.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Stud Bolts</div>
        <div class="product">Gasket</div>
        <div class="product">Pipes</div>
        <div class="product">Fittings</div>
        <div class="product">Flanges</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Pressure and Temperature Measurements</h2>
      <img src='images/products/Pressure_Measurements.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Differential Pressure Transmitter</div>
        <div class="product">Pressure Indicators</div>
        <div class="product">Differential Pressure Indicators</div>
        <div class="product">Temperature transmitters</div>
        <div class="product">Temperature indicators</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Manual Valves</h2>
      <img src='images/products/Manual_Valves.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Ball Valves</div>
        <div class="product">Globe Valves</div>
        <div class="product">Gate Valves</div>
        <div class="product">Check Valves</div>
        <div class="product">Butterfly Valves</div>
      </div>
    </div><!--
    --><div class="product-category">
      <h2>Flow & Level Measurements</h2>
      <img src='images/products/Flow_&_Level_Measurements.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Multiphase Flowmeters</div>
        <div class="product">Ultrasonic Flowmeters</div>
        <div class="product">Level Transmitter</div>
        <div class="product">Level Indicators</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Skid Mounted Packages</h2>
      <img src='images/products/Skid_Mounted_Packages.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Cooling Skid</div>
        <div class="product">Sampling Panels</div>
        <div class="product">LPG Basket Filter Package</div>
        <div class="product">Interpiping Skid</div>
      </div>
    </div>
    <div class="product-category">
      <h2>Instruments Bulk Material</h2>
      <img src='images/products/Instruments_Bulk_Material.png' class="product-category-picture" />
      <div class="product-list">
        <div class="product">Manifold Instruments Valves</div>
        <div class="product">Compression Fittings</div>
        <div class="product">Seamless Tubing</div>
      </div>
    </div>
  `,

  "pages:engineering:title": "Engineering",
  "pages:engineering:description": `
    <b>A.R.Technology offers Engineering Services including:</b>
    <ul>
      <li>Site Surveys</li>
      <li>Feasibility Studies</li>
      <li>Basic and Detailed Engineering Design</li>
      <li>System Architecture Design</li>
      <li>FAT & SAT</li>
      <li>Commissioning & Start Up</li>
      <li>After Sales Site Support</li>
      <li>Turn-Key applications</li>
      <li>Maintenance Engineering</li>
      <li>Recruitement and Provision of Technical Personnel</li>
      <li>Customized Training Courses</li>
    </ul>
  `,

  "pages:procurement:title": "Procurement",
  "pages:procurement:description": `
    <b>A.R.Technology offers high quality Procurement & Project Management Activities:</b>
    <ul>
      <li>Project Procurement</li>
      <li>Fast Track Supplies where time is essential</li>
      <li>Single items Supplies and according to the brand and origin requested by the Client</li>
      <li>Special supplies and manufacturing in strict accordance with client specification, including coating and painting</li>
      <li>Maintenance Procurement</li>
      <li>Negotiation of Service Contracts</li>
      <li>Suppliers and Manufacturers Market Research</li>
      <li>Expediting and Inspection, both internal and external by managing the third party</li>
      <li>National and International Shipments</li>
    </ul>
  `,

  "pages:quality:title": "Quality",
  "pages:quality:description": `
    <p class="qualita-text-1">A.R.Technology is committed to maintaining a constant quality control to ensure the best possible service and to offer its customers the products in strict accordance with the requirements and world standards. Quality is an integral part of A.R.Technology's business principles and inspires our actions to provide safe products and services. In fact, we believe that the reliability of a supplier is a determining factor for the company's development.</p>
    <p  style="text-align:right">
      <a href="documents/45001_EN.pdf" download><b>ISO 45001 Certificate |</b></a>
      <a href="documents/ISO_code_EN.pdf" download><b>ISO 9001 Certificate <span class='hide-mobile'>|</span></b></a><br class='show-mobile' />
      <a href="documents/politica_aziendale_EN.pdf" download><b>Company Policy |</b></a>
      <a href="documents/ethical_code_EN.pdf" download><b>Ethical Code</b></a>
    </p>
  `,

  "pages:news:title": "News",
  "pages:news:description": `<p class="news-text-1">A.R.Technology is proud to announce the opening of its new branch in Atyrau, Kazakhstan. The branch will be active starting from January, 4th 2018. More details coming soon.</p>`,

  "pages:contacts:title": "Contacts",
  "pages:contacts:description": `
    <p>
      Via Angelo Moro 119, 20097<br />
      S.Donato M.se, Italia<br />
      VAT: IT 08817750154
    </p>
    <p>
      Email: artechno@artechno.it
      <br />
      Tel: +39 02 5578271
      <br />
      Fax: +39 02 55782719
    </p>
    <p>
      <a href="documents/Informativa_Privacy_GDPR_en.pdf" style="text-transform:none" download>Information on the processing of personal data in accordance with the European regulation 679/2016 (GDPR)</a>
    </p>
  `,

  "pages:new-energy:title": "Renewable Energy Division",
  "pages:new-energy:description":
    "From 2018 the A.R.Technology S.r.l. has decided to expand its core business, specializing also in the design, supply and construction of plants for the production of electricity from renewable sources, in Italy and abroad.<br /><br />The ART, making use of important collaborations and a team of specialized technicians, is able to realize Photovoltaic Plants, Biomass Cogeneration Plants, Waste and Biogas / Biomethane. Furthermore, ART is investing important resources in the development of the Agriculture / Energy combination and is able to supply integrated greenhouse systems with thermal and electric power plants.<br />All types of systems can be supplied turnkey, including both the design / operational part and the after-sales service.<br /><br />All the systems produced meet the highest quality standards, current regulations and are in possession of all the required certifications.",

    "pages:new-partnership:title": "New Partnership with Solar Lighting International",
    "pages:new-partnership:description": `STEALTH 120-21 LED SOLAR STREET LIGHT <br><br> 
      <span style='font-weight: bold; margin-top: 10px;';>Features & Advantages</span> 
      <ul style='margin-top: 10px;'>
        <li>- Replaceable Parts - <span style='font-weight: bold';>Replaceable Battery | Replaceable Light Bar</span> </li>
        <li>- Unique Patented Design</li>
        <li>- Patented smart working modes for longer lighting time</li>
        <li>- Remote control add-on makes changing the work modes effortless</li>
        <li>- Professional light distribution optical lens for a wide lighting area</li>
        <li>- High Quality Mono-crystalline Solar Panel</li>
        <li>- LED light bars are adjustable to 40°</li>
        <li>- Wide angle detection enables body movement in a larger area and a longer distance</li>
      </ul>
      
      <br><br>
      <a style="padding: 0.8em 1.5em;
      background-color: white;
      border-radius: 32px;
      border: 2px solid #009119;
      color: #009119;
      display: inline-block;
      margin-left: 4em;
      vertical-align: middle;
      font-size: 15px;
      font-weight: 600;" href='documents/SLI-STEALTH-LED-Solar-street-light.pdf' download><b>Download Product's PDF</b></a>
    `,   

  "app:language:it": "it",
  "app:language:en": "en",
  "app:language:ru": "ru",

  "projects:VE1:name":
    "<p>Project: PERLA<br>Contractor:  NAPEA INTERNATIONAL INC<br>Final Client:  CARDON IV<br>Destination:  VENEZUELA<br>Scope of supply:  SUPPLY OF PIPE MATERIAL</p>",
  "projects:VE2:name":
    "<p>Project: PERLA<br>Contractor:  CARDON IV<br>Final Client:  CARDON IV<br>Destination:  VENEZUELA<br>Scope of supply:  MATERIAL FOR FLOWLINES</p>",
  "projects:IT:name":
    "<p>Project: N/A<br>Contractor:  SAIPEM SPA<br>Final Client:  SAIPEM SPA<br>Destination:  ITALY<br>Scope of supply:  PROCUREMENT SERVICES</p>",
  "projects:KZ1:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM<br>ESKENE WEST RAIL PROJECT<br>Contractor:  EUSEBI IMPIANTI SRL<br>Final Client:  NCOC (Ex AGIP KCO)<br>Destination:  KAZAKHSTAN<br>Scope of supply:  INSTRUMENTAL BULK & SAMPLING SKIDS</p>",
  "projects:KZ2:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM<br>ESKENE WEST RAIL PROJECT<br>Contractor:  BERTRAMS HEATEC AG<br>Final Client:  NCOC (Ex AGIP KCO)<br>Destination:  KAZAKHSTAN<br>Scope of supply:  VALVES</p>",
  "projects:KZ3:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: ISKER CONSORTIUM LLP<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: INSTRUMENTAL BULK & CABLE TRAYS</p>",
  "projects:KZ4:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: KELBURN ENGINEERING LTD<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: VALVES</p>",
  "projects:KZ5:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: PSN KAZSTROY JSC<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: INSTRUMENTAL, ELECTRICAL AND F&G MATERIAL</p>",
  "projects:KZ6:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: PSN KAZSTROY JSC<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: HEAT EXCHANGER GASKETS</p>",
  "projects:KZ7:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: WORLEYPARSONS LTD<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: GASKETS, BOLTS & SPARES</p>",
  "projects:KZ8:name":
    "<p>Project: KASHAGAN DEVELOPMENT EXPERIMENTAL PROGRAM ESKENE WEST RAIL PROJECT<br>Contractor: SEASTAR INTERNATIONAL<br>Final Client: NCOC (Ex AGIP KCO)<br>Destination: KAZAKHSTAN<br>Scope of supply: BOLTS, NUTS, SCREW, WASHER</p>",
  "projects:KZ9:name": "<p>NEW OPENING IN ATYRAU!</p>",
  "projects:DZ1:name":
    "<p>Project: ON SHORE LEDJMET BLOCK 405b CAF C GAS GATHERING<br>Contractor:  SH FCP - SONATRACH<br>Final Client:  SH FCP - SONATRACH<br>Destination:  ALGERIA<br>Scope of supply:  FIELD INSTRUMENTS & PIPING BULK MATERIALS</p>",
  "projects:DZ2:name":
    "<p>Project: CHAMPS BRN&ROD BLOCKS 401A & 402A<br>Contractor:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Final Client:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Destination:  ALGERIA<br>Scope of supply:  VALVES & PIPING BULK MATERIAL</p>",
  "projects:DZ3:name":
    "<p>Project: MACARONI STRINGS REINTEGRATION PROGRAM<br>Contractor:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Final Client:  GROUPEMENT SONATRACH-AGIP (GSA)<br>Destination:  ALGERIA<br>Scope of supply:  MACARONI STRINGS</p>",
  "projects:EG1:name":
    "<p>Project: ZOHR<br>Contractor:  ENPPI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  EFW AND SEAMLESS PIPES</p>",
  "projects:EG2:name":
    "<p>Project: ZOHR<br>Contractor:  ENPPI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  FITTINGS AND PIPING</p>",
  "projects:EG3:name":
    "<p>Project: ZOHR<br>Contractor:  ENPPI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  INSTRUMENTATION AND ELECTRICAL MATERIAL</p>",
  "projects:EG4:name":
    "<p>Project: ZOHR<br>Contractor:  PETROJET<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  PIG TRAPS</p>",
  "projects:EG5:name":
    "<p>Project: NIDOCO NORTH WEST GAS DEVELOPMENT PROJECT<br>Contractor:  PETROBEL BELAYM PRETROLEUM - ENI<br>Final Client:  PETROBEL BELAYM PRETROLEUM - ENI<br>Destination:  EGYPT<br>Scope of supply:  SUPPLY OF FLANGES</p>",
  "projects:EG6:name":
    "<p>Project: VARIOUS<br>Contractor:  BAPETCO (BADR PETROLEUM COMPANY)<br>Final Client:  SHELL<br>Destination:  EGYPT<br>Scope of supply:  INSTRUMENTS & BULK MATERIALS</p>",
  "projects:EG7:name":
    "<p>Project: UGDC LNG PLANT PORT SAID IMPROVEMENT<br>Contractor:  UNITED GAS AND DERIVATES (UGDC)<br>Final Client:  ENI – BP - GASCO<br>Destination:  EGYPT<br>Scope of supply:  VALVES</p>",
  "projects:CD1:name":
    "<p>Project: VARIOUS PLATFORMS<br>Contractor:  NUOVA O.M.A.<br>Final Client:  ENI CONGO<br>Destination:  CONGO<br>Scope of supply:  PIPING BULK MATERIAL & VALVES</p>",
  "projects:CD2:name":
    "<p>Project: C23932 ENI CONGO KITINA & AEP<br>Contractor:  SAIPEM<br>Final Client:  ENI CONGO<br>Destination:  CONGO<br>Scope of supply:  FIELD INSTRUMENTS</p>",
  "projects:TN1:name":
    "<p>Project: MAAMOURA & BARAKA<br>Contractor:  ENI TUNISIA B.V.<br>Final Client:  ENI TUNISIA B.V.<br>Destination:  TUNISIA<br>Scope of supply:  FIELD INSTRUMENTS</p>",
  "projects:TN2:name":
    "<p>Project: BIR BEN TARTAR EPF<br>Contractor:  MEDCO ENERGI INTERNATIONAL<br>Final Client:  MEDCO ENERGI INTERNATIONAL<br>Destination:  TUNISIA<br>Scope of supply:  PIPING BULK MATERIAL</p>",
};



// WEBPACK FOOTER //
// ./src/dictionaries/en.js